import type { ButtonProps} from "@chakra-ui/react";
import { useMediaQuery, Button, Box } from "@chakra-ui/react";
import {ContainerButtons, Layout} from "./style";
import React from "react";
import { minWidth800BP } from "../../constants";

interface IProps {
	primaryButton: ButtonProps;
	secondaryButton?: ButtonProps;
	children?: JSX.Element | React.Component;
	shadowOn?: boolean;
	fixedComponent?: React.ReactElement;
	isFixed?: boolean;
	primaryButtonWidth?: string;
	bgButtons?: string;
	additionalMB?: boolean;
	buttonStyles?: React.CSSProperties;
	containerButtonStyle?: React.CSSProperties;
}

export const ButtonFixedLayout = ({ primaryButton, secondaryButton, shadowOn = false, children, fixedComponent, containerButtonStyle, isFixed, bgButtons, primaryButtonWidth, additionalMB, buttonStyles }: IProps): JSX.Element => {
	const [isLargerThan800] = useMediaQuery(minWidth800BP);

	const btnWidth = primaryButtonWidth ? primaryButtonWidth : "auto";

	return (
		<>
			<Layout isDesktop={isLargerThan800} style={containerButtonStyle}>
				<>
					{children}
					{isLargerThan800 && fixedComponent}
					{!isLargerThan800 && additionalMB && <Box mb='110px'/>}
				</>
			</Layout>
			<ContainerButtons
				style={{backgroundColor: bgButtons ? bgButtons : "white", padding: "24px", ...buttonStyles}}
				isDesktop={isLargerThan800}
				shadowOn={shadowOn}
				isFixed={isLargerThan800 ? false : isFixed}
			>
				{!isLargerThan800 && fixedComponent}
				{isLargerThan800 ?
					(
						<>
							{secondaryButton && <Button w={"auto"} {...secondaryButton}>{secondaryButton.title}</Button>}
							<Button w={btnWidth} {...primaryButton}>{primaryButton.title}</Button>
						</>
					) : (
						<>
							<Button w={"full"} {...primaryButton}>{primaryButton.title}</Button>
							{secondaryButton && <Button w={"full"} {...secondaryButton}>{secondaryButton.title}</Button>}
						</>
					)
				}
			</ContainerButtons>
		</>
	);
};
